import React, {useState} from "react";
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {connect, useSelector} from "react-redux";
import {useForm} from "react-hook-form";


// components
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";

// labels
import {LB_CODE, LB_ACTIVE, LB_TITLE, LB_EVENT} from "../../../components/i18n/i18n";
import {PH_CODE, PH_TITLE} from "../../../components/i18n/placeHolders";

// actions
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";
import SelectGeneric from "../../../components/select/selectGeneric";
import {eventProvider} from "../../../providers/eventx/eventProvider";



const SectionFilters = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app, udn } = componentState?.data || {};
    const {fbDataBase} = app

    const [event, setEvent] = useState(filter?.item?.event?.id || null);
    const [status, setStatus] = useState(filter?.status || null);
    const [onlyRegistered, setOnlyRegistered] = useState( true);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            title: filter?.title || '',
            code: filter?.code || ''
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase,
            onlyRegistered : onlyRegistered,
            item : {
                ...data,
            }
        };

        if (event !== undefined && event !== null)
            dataFilter.item.event = { id: event };

        if (status !== undefined && status !== null)
            dataFilter.item.status = status;

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setEvent(null);
        setStatus(null);
        setOnlyRegistered(true);
        reset({
            code: '',
            title: ''
        });
    }

    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <CardBody>
            <Row>
                <Col md={'4'}>
                    <FormGroup>
                        <Label>{LB_EVENT}</Label>
                        <SelectGeneric
                            provider={eventProvider}
                            initialValue={event}
                            setExternalValue={setEvent}
                            customFilter={
                                app?.code === 'EVENTS'
                                    ? { item: { udn: {id: udn?.id }, status: true }}
                                    : {}
                            }
                        />
                    </FormGroup>
                </Col>

                <Col md="4">
                    <FormGroup>
                        <Label>{LB_CODE}</Label>
                        <Input
                            type="text"
                            name="code"
                            placeholder={PH_CODE}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>

                <Col md="4">
                    <FormGroup>
                        <Label>{LB_TITLE}</Label>
                        <Input
                            type="text"
                            name="title"
                            placeholder={PH_TITLE}
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>

                <Col md="2">
                    <FormGroup>
                        <Label>{LB_ACTIVE}</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={status}
                            onChange={ () => setStatus(!status) }
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>{'Solo en app'}</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={onlyRegistered}
                            onChange={ () => setOnlyRegistered(!onlyRegistered) }
                        />
                    </FormGroup>
                </Col>
                <Col sm={12} className={'d-flex justify-content-center'}>
                    <div className="float-right ">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(SectionFilters)